import { selectSystemTenantConfig } from '@/features/system/store/selectors';
import { ConditionGuard } from '@/components/guards/ConditionGuard/ConditionGuard';
import { useSelector } from '@/store/hooks';

const AppHelmet = () => {
  const tenantConfiguration = useSelector(selectSystemTenantConfig);
  return (
    <>
      <title>{tenantConfiguration?.appName}</title>
      <ConditionGuard condition={Boolean(tenantConfiguration && 'favicon' in tenantConfiguration)}>
        <link rel="icon" href={tenantConfiguration?.favicon} />
      </ConditionGuard>
    </>
  );
};

export default AppHelmet;
